import { Injectable } from '@angular/core';
import { ClassProvider } from '../class';
import { DatasetType } from '../dataset';
import { TruePositiveDefinition, ResultName, AnomalyRecognitionDatasetClasses } from './anomaly-stats.service';

export interface TestOutcomes {
    [key: string]: ResultName;
}

@Injectable()
export class TestOutcomeService {
    constructor(private classProvider: ClassProvider) {}

    public getTestOutcomes(
        datasetType: DatasetType,
        predictedClass: string,
        actualClass: string,
        tpp: TruePositiveDefinition | null
    ): TestOutcomes {
        if (datasetType == DatasetType.SceneRecognition) {
            return this.getTestOutcomesForSceneRecognition(predictedClass, actualClass);
        } else {
            return this.getTestOutcomesForAnomalyRecognition(predictedClass, actualClass, tpp);
        }
    }

    /**
     * Returns test outcomes for a SceneRecognition dataset for both the predicted and ground truth classes
     *
     * @param {string} predictedClass
     * @param {string} groundTruth
     * @returns {TestOutcomes}
     */
    public getTestOutcomesForSceneRecognition(predictedClass: string, actualClass: string): TestOutcomes {
        const testOutcomes = {};

        if (predictedClass === actualClass) {
            testOutcomes[predictedClass] = ResultName.TP;
        } else {
            if (this.classProvider.isClassNothingIKnow(actualClass)) {
                testOutcomes[actualClass] = ResultName.FN;
            } else if (this.classProvider.isClassNothingIKnow(predictedClass)) {
                testOutcomes[actualClass] = ResultName.FN;
            } else {
                testOutcomes[actualClass] = ResultName.FN;
                testOutcomes[predictedClass] = ResultName.FP;
            }
        }

        return testOutcomes;
    }

    public getTestOutcomesForAnomalyRecognition(
        predictedClass: string,
        actualClass: string,
        tpp: TruePositiveDefinition | null
    ): TestOutcomes {
        if (tpp === null || tpp == TruePositiveDefinition.PREDICTED_NORMAL_IS_NORMAL) {
            return this.getTestOutcomesForARWithTPPeSetToNormal(predictedClass, actualClass);
        } else {
            return this.getTestOutcomesForARWithTPPSetToAnomaly(predictedClass, actualClass);
        }
    }

    public getTestOutcomesForARWithTPPeSetToNormal(predictedClass: string, actualClass: string): TestOutcomes {
        const testOutcomes = {};

        if (
            actualClass === AnomalyRecognitionDatasetClasses.Normal &&
            predictedClass == AnomalyRecognitionDatasetClasses.Normal
        ) {
            testOutcomes[predictedClass] = ResultName.TP;
        }

        if (
            actualClass === AnomalyRecognitionDatasetClasses.Anomaly &&
            predictedClass == AnomalyRecognitionDatasetClasses.Anomaly
        ) {
            testOutcomes[predictedClass] = ResultName.TN;
        }

        if (
            actualClass === AnomalyRecognitionDatasetClasses.Normal &&
            predictedClass == AnomalyRecognitionDatasetClasses.Anomaly
        ) {
            testOutcomes[actualClass] = ResultName.FN;
            testOutcomes[predictedClass] = ResultName.FN;
        }

        if (
            actualClass === AnomalyRecognitionDatasetClasses.Anomaly &&
            predictedClass == AnomalyRecognitionDatasetClasses.Normal
        ) {
            testOutcomes[actualClass] = ResultName.FP;
            testOutcomes[predictedClass] = ResultName.FP;
        }

        return testOutcomes;
    }

    public getTestOutcomesForARWithTPPSetToAnomaly(predictedClass: string, actualClass: string): TestOutcomes {
        const testOutcomes = {};

        if (
            actualClass === AnomalyRecognitionDatasetClasses.Normal &&
            predictedClass == AnomalyRecognitionDatasetClasses.Normal
        ) {
            testOutcomes[predictedClass] = ResultName.TN;
        }

        if (
            actualClass === AnomalyRecognitionDatasetClasses.Anomaly &&
            predictedClass == AnomalyRecognitionDatasetClasses.Anomaly
        ) {
            testOutcomes[predictedClass] = ResultName.TP;
        }

        if (
            actualClass === AnomalyRecognitionDatasetClasses.Normal &&
            predictedClass == AnomalyRecognitionDatasetClasses.Anomaly
        ) {
            testOutcomes[actualClass] = ResultName.FP;
            testOutcomes[predictedClass] = ResultName.FP;
        }

        if (
            actualClass === AnomalyRecognitionDatasetClasses.Anomaly &&
            predictedClass == AnomalyRecognitionDatasetClasses.Normal
        ) {
            testOutcomes[actualClass] = ResultName.FN;
            testOutcomes[predictedClass] = ResultName.FN;
        }

        return testOutcomes;
    }
}



// WEBPACK FOOTER //
// ./src/providers/evaluate_brain/test-outcome.service.ts